<vitamui-common-confirm-dialog
  [dialogTitle]="data?.title | translate"
  [dialogSubTitle]="data?.subTitle | translate"
  [confirmLabel]="data?.confirmLabel | translate"
  [cancelLabel]="data?.cancelLabel | translate"
>
  {{ data?.message }}
</vitamui-common-confirm-dialog>
